
import logoImg from '@/assets/magLogo.png'
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
name: 'Header',
props: {
sub_title: {
type: String,
default: '',
}
},
components: {
XHeader
},
data() {
return {
logoImg: logoImg,
leftOptions:{showBack: false},
}
},
created() {},
mounted() {}
}



// WEBPACK FOOTER //
// ./src/components/HeaderMag.vue